import React from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import { connect } from 'react-redux';
import { Card, Col, Row, Table, Alert, FormGroup, Input, Label } from 'reactstrap';
import { MdDelete } from 'react-icons/md';
import { ImBook, ImPlus } from 'react-icons/im';
import { Spinner } from 'react-bootstrap';
import ListTutorialComponent from '../../../components/Admin/tutorials/ListTutorialComponent';
import PaginateComponent from  '../../../components/PaginateComponent';
import ModalComponent from  '../../../components/ModalComponent';

import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';

class TutorialPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			error: false,
			perPage: 0,
			totalPage: 0,
			currentPage: 0,
			from: '',
            to: '',
			messageError: '',
			isNotification: '',
			textNotification: '',
			isSpinner: false,
			listTutorial: [],
			checkedTutorialIds: [],

			isModal: false,
			isBtnConfirm: true,
            btnConfirmDisabled: false,
            titleModal: '',
            modalBody: '',
			contentModal: '',
			alert: {
                error: false,
                message: ''
            },
            action: '',
            actionKey: 0,

            tutorialId: 0,
			title: '',
			link: '',
			description: '',

			rq_table: {
                per_page: 10,
                page: 0,
                s: '',
                order_by: 'id',
                order: 'desc',
            },
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getListTutorial();
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	getListTutorial = () => {
		this.setState({
			isLoading: true
		});

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: this.state.rq_table
		}
		axios.get( process.env.REACT_APP_API_URL + '/api/admin/tutorial/list', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					listTutorial: ref.data.content.data,
					rq_table: ref.data.content.filters,
					perPage: ref.data.content.perPage,
                    totalPage: ref.data.content.total,
                    currentPage: ref.data.content.current_page,
                    from: ref.data.content.from,
                    to: ref.data.content.to
				});
				this.state.listTutorial.forEach( tutorial => {
					tutorial.checked = false;
		        });
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

	confirmDeleteTutorial = (id) => {
		confirmAlert({
	      	title: '',
	      	message: `Xác nhận xóa hướng dẫn này?`,
	      	buttons: [
		        {
		          	label: 'Xóa',
		          	onClick: () => {
		          		this.confirmDeleteTutorialRequest(id);
		          	}
		        },
		        {
		          	label: 'Hủy',
		          	onClick: () => false
		        }
	      	]
	    });
	}

	confirmDeleteTutorialRequest = (id) => {
		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};
		let params = {id: id};
		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			}
		}

		axios.post( process.env.REACT_APP_API_URL + '/api/admin/tutorial/delete', params, config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
				isNotification: '',
				textNotification: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
				},
				() => this.getListTutorial()
				)
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

	editModal = (id) => {

	}

	listTutorialRow = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listTutorial.length ) {
                return (
                    this.state.listTutorial.map( (tutorial, key) => {
                        return (
                            <ListTutorialComponent
	                            key={key}
	                            tutorial={tutorial}
	                            actionKey={key}
	                            showModal={ (actionKey, action) => this.showModal(actionKey, action) }
	                            confirmDelete={ (id) => this.confirmDeleteTutorial(id) }
	                            checkedTutorial = { (actionKey) => this.checkedTutorial(actionKey) }
                                checkedTutorialShiftKey = { (actionKey, value) => this.checkedTutorialShiftKey(actionKey, value) }
                            />
                        )
                    })
                );
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có dữ liệu!
                        </td>
                    </tr>
                );
            }
        }
    }

    checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	sort = (order_by) => {
		this.setState(
			{
				rq_table: {
			        ...this.state.rq_table, 
					order_by: order_by, 
					order: this.state.rq_table.order === 'desc' ? 'asc' : 'desc'
			    }
			},
			() => this.getListTutorial()
		)
	}	

	change = (e) => {
		this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value,
					page: 0
			    }
			},
			() => this.getListTutorial()
		)
	}

	changeInput = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		})
	}

    changeQtt = async (event) => {
        let value = event.target.value;
        await this.setState({
            rq_table: {
                ...this.state.rq_table, 
                per_page: value,
                page: 0,
            }
        })
        await this.getListTutorial();
    }

    search = (e) => {
	    this.setState(
	    	{
		    	rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value
			    }
		    }
	    )
    }

    submitSearch = (e) => {
        if(e.key === 'Enter') {
        	this.setState(
				{
					currentPage: 0,
					rq_table: {
				        ...this.state.rq_table,
						page: 0
				    }
				},
				() => this.getListTutorial()
			)
        }
    }

    btnSearch = () => {
        this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table,
					page: 0
			    }
			},
			() => this.getListTutorial()
		)
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
		this.setState(
			{
				currentPage: page,
				rq_table: {
			        ...this.state.rq_table, 
					page: page
			    }
			},
			() => this.getListTutorial()
		)
    }

    checkAll = (e) => {
        let value = e.target.checked;
        let listTutorial = this.state.listTutorial;
        listTutorial.forEach( email => {
            email.checked = value;
        });
        this.setState({
            checkAll: value,
            listTutorial: listTutorial
        });
        this.checkedTutorialIds(listTutorial);
    }


    checkedTutorial  = (actionKey) => {
        let listTutorial = this.state.listTutorial;
        listTutorial[actionKey].checked = !listTutorial[actionKey].checked;
        this.setState({
            listTutorial: listTutorial,
            checkedStart: actionKey
        });
        this.checkedTutorialIds(listTutorial);
    }

    checkedTutorialShiftKey = (actionKey, value) => {
        if ( this.state.checkedStart !== -1 ) {
            let listTutorial = this.state.listTutorial;
            let n = Math.abs( actionKey - this.state.checkedStart );
            let i = this.state.checkedStart;
            let k = actionKey;
            if ( actionKey < this.state.checkedStart ) {
                i = actionKey;
                k = this.state.checkedStart;
            }
            for (i; i <= n; i++) {
                listTutorial[i].checked = value;
            }
            this.setState({
                listTutorial: listTutorial,
                checkedStart: k
            });
            this.checkedTutorialIds(listTutorial);
        } else {
            let listTutorial = this.state.listTutorial;
            listTutorial[actionKey].checked = !listTutorial[actionKey].checked;
            this.setState({
                listTutorial: listTutorial,
                checkedStart: actionKey
            });
            this.checkedTutorialIds(listTutorial);
        }
    }

    checkedTutorialIds = (listTutorial) => {
    	let checkedTutorialIds = [];
    	listTutorial.forEach( tutorial => {
    		if (tutorial.checked) {
    			checkedTutorialIds.push(tutorial.id)
    		}
        });
        this.setState({
        	checkedTutorialIds: checkedTutorialIds
        })
    }

    confirmDeleteCheckedTutorial = () => {
    	if (this.state.checkedTutorialIds.length) {
    		confirmAlert({
		      	title: '',
		      	message: 'Xác nhận xóa các mục đã chọn?',
		      	buttons: [
			        {
			          	label: 'Xóa mục đã chọn',
			          	onClick: () => { this.confirmDeleteCheckedTutorialRequest() }
			        },
			        {
			          	label: 'Hủy',
			          	onClick: () => false
			        }
		      	]
		    });
    	} else {
    		confirmAlert({
		      	title: '',
		      	message: 'Bạn chưa chọn mục để xóa?',
		      	buttons: [
			        {
			          	label: 'OK',
			          	onClick: () => false
			        }
		      	]
		    });
    	}
    }

    confirmDeleteCheckedTutorialRequest = () => {

    	let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};
		let params = {ids: this.state.checkedTutorialIds}
		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			}
		}

		axios.post( process.env.REACT_APP_API_URL + '/api/admin/tutorial/multi-delete', params, config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
				isNotification: '',
				textNotification: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
					checkedTutorialIds: [],
				},
				() => this.getListTutorial()
				)
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
    }

    loadQttChecked = () => {
        let n = 0;
        if ( this.state.listTutorial.length ) {
            this.state.listTutorial.forEach( tutorial => {
                if ( tutorial.checked ) {
                    n++;
                }
            })
        }
        return (n);
    }

    showModal = (key, action) => {
    	let titleModal;
    	let modalBody;
        if ( action === 'create' ) {
        	titleModal = 'Thêm hướng dẫn';
        	modalBody =  this.modalBody(action, {});
        } else if ( action === 'edit' ) {
        	titleModal = 'Cập nhập hướng dẫn';
        	modalBody =  this.modalBody(action, this.state.listTutorial[key]);
        	this.setState({
        		tutorialId: this.state.listTutorial[key].id,
        		title: this.state.listTutorial[key].title,
        		link: this.state.listTutorial[key].link,
        		description: this.state.listTutorial[key].description,
        	});
        }

        this.setState({
        	isModal: true,
            action: action,
            btnConfirmDisabled: false,
            isBtnConfirm: true,
            actionKey: key,
            contentModal: {
            	title: titleModal,
                modalBody: modalBody
            }
        });
    } 

    modalBody = (action, tutorial) => {
    	if ( action === 'create' ) {
            return (
            	<>
	            	<FormGroup>
						<Label for="title">Tiêu đề</Label>
						<Input
							type="text"
							id="title"
							name="title"
							placeholder="Nhập tiêu đề"
							onChange={ this.changeInput }
						/>
					</FormGroup>
					<FormGroup>
						<Label for="link">Đường dẫn (Link)</Label>
						<Input
							type="text"
							id="link"
							name="link"
							placeholder="Nhập đường dẫn"
							onChange={ this.changeInput }
						/>
					</FormGroup>
					<FormGroup>
	                  	<Label for="description">Mô tả</Label>
	                  	<textarea
	                  		className="form-control"
	                  		id="description"
	                  		name="description"
	                  		placeholder="Nhập mô tả ..."
	                  		rows="5"
	                  		onChange={ this.changeInput }
	              		></textarea>
	                </FormGroup>
	        	</>
            );
    	} else if ( action === 'edit' ) {
			return (
	            <>
	            	<FormGroup>
						<Label for="title">Tiêu đề</Label>
						<Input
							type="text"
							id="title"
							name="title"
							placeholder="Nhập tiêu đề"
							defaultValue={ tutorial.title }
							onChange={ this.changeInput }
						/>
					</FormGroup>
					<FormGroup>
						<Label for="link">Đường dẫn (Link)</Label>
						<Input
							type="text"
							id="link"
							name="link"
							placeholder="Nhập đường dẫn"
							defaultValue={ tutorial.link }
							onChange={ this.changeInput }
						/>
					</FormGroup>
					<FormGroup>
	                  	<Label for="description">Mô tả</Label>
	                  	<textarea
	                  		className="form-control"
	                  		id="description"
	                  		name="description"
	                  		placeholder="Nhập mô tả ..."
	                  		rows="5"
	                  		defaultValue={ tutorial.description } 
	                  		onChange={ this.changeInput }
	              		></textarea>
	                </FormGroup>
	        	</>
	        )
    	}
    }

    hiddenModal = () => {
        this.setState({
            action: '',
            isModal: false,
            alert: {
                error: false,
                message: ''
            },
            tutorialId: 0,
    		title: '',
    		link: '',
    		description: '',
        })
    }

    confirmModal = () => {
    	let validateModal = this.validateModal();
    	if (validateModal) {
    		this.setState({
    			isSpinner: true,
    			btnConfirmDisabled: true,
                alert: {
	                error: false,
	                message: ''
	            }
            });
    		let dataAuth = {
				username: process.env.REACT_APP_CLIENT_ID,
				password: process.env.REACT_APP_CLIENT_PASSWD,
				token: process.env.REACT_APP_KEY,
			};
			let params = {
				action: this.state.action,
				id: this.state.tutorialId,
				title: this.state.title,
				link: this.state.link,
				description: this.state.description
			}
			let config = {
			  	headers: {
					'Content-Type': 'application/json',
					'Authorization' : this.props.token,
					'dataAgency' : JSON.stringify(dataAuth)
				}
			}

			axios.post( process.env.REACT_APP_API_URL + '/api/admin/tutorial/create-or-edit', params, config)
			.then( (ref) => {
				// console.log(ref.data);
				this.setState({
					isSpinner: false,
					isLoading: false,
					btnConfirmDisabled: false,
					error: false,
					messageError: '',
					isNotification: '',
					textNotification: '',
				});
				if ( ref.data.error === 0 ) {
					this.setState({
						isNotification: true,
						textNotification: ref.data.message,
						tutorialId: 0,
						title: '',
						link: '',
						description: ''
					});
					this.getListTutorial();
					this.hiddenModal();
				} else {
					if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
						this.props.logOut();
					} else {
						this.setState({
							alert: {
				                error: true,
				                message: ref.data.message,
				            }
						})
					}
				}
			})
			.catch( (error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					isSpinner: false,
					alert: {
		                error: true,
		                message: 'Lấy dữ liệu thất bại',
		            }
				})
			})
    	}
    }

    validateModal = () => {
    	if ( this.state.title.length === 0 ) {
            this.setState({
                alert: {
	                error: true,
	                message: 'Tiêu đề không được để trống'
	            }
            })
            return false;
        } else if (this.state.link.length === 0) {
        	this.setState({
                alert: {
	                error: true,
	                message: 'Đường dẫn không được để trống'
	            }
            })
            return false;
        }
        return true;
    }

	render() {
		return (
			<>
                <Breadcrumb title={"Quản lý hướng dẫn"} page={"Quản lý hướng dẫn"} icon={<ImBook className="breadcrumb-icon" />} />

                <Row>
					<Col sm={12}>
						{ this.state.error ? (<Alert color="danger"><div className='text-center'>{ this.state.messageError }</div></Alert>) : (<></>)}
						{this.checkNotification()}

					</Col>
				</Row>
				<Row className="my-3">
					<Col sm={12}>
						<button
							className={`btn btn-success btn-sm`}
							onClick={ () => this.showModal(0, 'create') }
						>
							<ImPlus /> Thêm hướng dẫn
						</button>
					</Col>
				</Row>

                <Card body>
                    <Row>
                    	<Col sm={12} className="form-inline mb-2">
                    		<select className="form-control form-control-sm mr-1" style={{ maxWidth: 70 }} value={this.state.rq_table.per_page} onChange={ this.changeQtt }>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                            </select>
							<button
								className={`btn btn-${this.state.checkedTutorialIds.length ? 'danger' : 'outline-danger'} btn-sm`}
								onClick={ () => this.confirmDeleteCheckedTutorial() }
							>
								<MdDelete /> Xóa mục chọn
							</button>
						</Col>
						{
	                        this.state.listTutorial.length ? (
	                        	<>
	                        		<Col md={12}>
		                                Hiển thị từ { this.state.from } đến { this.state.to } / Tổng: { this.state.totalPage }
		                            </Col>
		                            <Col md={12} className="text-primary mb-3">
				                        <b>
				                            Đã chọn:
				                            <span className="qtt-checkbox"> { this.loadQttChecked() }</span> / <span className="total-item">{ this.state.listTutorial.length }</span>
				                        </b>
				                    </Col>
	                	 		</>
	                        ) : (
	                        <></>
	                        )
	                    }
                    	<Col sm={12} className="table-responsive">
                    		<Table className="table table-sm table-bordered table-hover rounded">
		                        <thead className="primary">
		                            <tr>
		                            	<th className="text-center" width="5%">
		                            		<input
									          	type="checkbox"
									          	defaultValue={false}
									          	onChange={ this.checkAll }
									        />
		                            	</th>
		                                <th className={'text-center'} width="50%">Tiêu đề</th>
		                                <th className={'text-center'} width="35%">Mô tả</th>
		                                <th className={'text-center'} width="10%">Action</th>
		                            </tr>
		                        </thead>
		                        <tbody>
		                            { this.listTutorialRow() } 
		                        </tbody>
		                    </Table>
		                    <Row>
		                    	{
			                        this.state.listTutorial.length ? (
			                        	<>
			                        		<Col md={12} className="mb-2">
				                                Hiển thị từ { this.state.from } đến { this.state.to } / Tổng: { this.state.totalPage }
				                            </Col>
			                	 		</>
			                        ) : (
			                        <></>
			                        )
			                    }
		                    </Row>
		                    { this.paginate() }
                    	</Col>
                    </Row>
                </Card>
                <ModalComponent
                    isModal={ this.state.isModal }
                    content={this.state.contentModal}
                    isBtnConfirm={ this.state.isBtnConfirm }
                    isSpinner={ this.state.isSpinner }
                    btnConfirmDisabled={ this.state.btnConfirmDisabled }
                    hiddenModal={ () => this.hiddenModal() }
                    confirmModal={ () => this.confirmModal() }
                    alert={ this.state.alert }
                />
            </>	
		)
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminTutorial' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(TutorialPage);